import { render, staticRenderFns } from "./favorite-express.vue?vue&type=template&id=766617af&scoped=true&"
import script from "./favorite-express.vue?vue&type=script&lang=js&"
export * from "./favorite-express.vue?vue&type=script&lang=js&"
import style0 from "./favorite-express.vue?vue&type=style&index=0&id=766617af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766617af",
  null
  
)

export default component.exports